// pc端导航
import { rgba } from "polished";
import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { animated, useSpring } from "react-spring";
import styled from "styled-components";
import EthMonitor from './EthMonitor';
import Monitor from "./Monitor";
import { CoinIcon, color, Flex, Hidden, ScrollView, shadow, Text, View } from "./Styles";

export default ({
  isLandingPage,
  iostHandler,
  currentCoin,
  compondYearYield,
  ethCompondYearYield,
  ethTotalProfit,
  screen
}) => {
  const { t } = useTranslation();

  const HomeButtonMotion = useSpring({
    opacity: isLandingPage ? 0 : 1,
    width: isLandingPage ? 0 : 120
  });

  if (isLandingPage && screen === 'mobile') {
    return <Flex jcsb aic style={{ justifyContent: 'space-around' }} >
      <View mb={0.5}>
        <CoinNavLink
          abbr="eth"
          name="ETH"
          description={t("年化 {{v}}%", { v: ethCompondYearYield })}
        />
      </View>
      <View mb={0.5}>
        <CoinNavLink
          abbr="iost"
          name="IOST"
          description={t("年化 {{v}}%", { v: compondYearYield })}
        />
      </View>
    </Flex>
  }
  return (
    <View aic>
      <Hidden mobile>
        <ScrollView>
          <Flex p={2} jcc aic>
            <animated.div style={HomeButtonMotion}>
              <Flex pr={1.5}>
                <View flex="none" pr={1.5} mr={1.5} br={color.border.sm}>
                  <CoinNavLink exact />
                </View>
              </Flex>
            </animated.div>

            <Flex gap={1.5}>
              <CoinNavLink abbr="eth" name="ETH" description={t("年化 {{v}}%", { v: ethCompondYearYield })} />
              <CoinNavLink
                abbr="iost"
                name="IOST"
                description={t("年化 {{v}}%", { v: compondYearYield })}
              />
              {/*<CoinNavLink */}
              {/*abbr="ksm" */}
              {/*name="KSM"*/}
              {/*description={t("年化 {{v}}%",{v:compondKsmYearYield})} />*/}
              <CoinNavLink abbr="dot" description={t("即将上线")} />
              <CoinNavLink abbr="eos" description={t("即将上线")} />
              <CoinNavLink abbr="pcx" description={t("即将上线")} />
              <CoinNavLink abbr="atom" description={t("即将上线")} />
            </Flex>
          </Flex>
        </ScrollView>
      </Hidden>

      {currentCoin === "eth" && (
        <EthMonitor
          iostHandler={iostHandler}
          compondYearYield={ethCompondYearYield}
          ethTotalProfit={ethTotalProfit}
        />
      )}
      {currentCoin === "iost" && (
        <Monitor
          iostHandler={iostHandler}
          compondYearYield={compondYearYield}
        />
      )}

      {currentCoin === "ksm" && (
        <Monitor
          iostHandler={iostHandler}
          compondYearYield={compondYearYield}
        />
      )}
    </View>
  );
};

export const CoinNavLink = props => (
  <StyledCoinNavLink
    key={props.name}
    to={"/" + (props.abbr ? props.abbr : "")}
    exact={props.exact}
    color={(function () {
      let navColor;

      switch (props.abbr) {
        case "iost":
          navColor = color.iost;
          break;
        case "eth":
          navColor = color.eth;
          break;
        case "eos":
          navColor = color.eos;
          break;
        case "atom":
          navColor = color.atom;
          break;
        case "lpt":
          navColor = color.lpt;
          break;
        case "ksm":
          navColor = color.ksm;
          break;
        case "lol":
          navColor = color.lol;
          break;
        case "pcx":
          navColor = color.pcx;
          break;
        case "dot":
          navColor = color.dot;
          break;
        default:
          navColor = color.lightGray;
          break;
      }

      return navColor;
    })()}
  >
    <CoinIcon abbr={props.abbr} />
    {props.abbr && (
      <View ml={0.75} mr={1.5}>
        <Text bold uppercase>
          {props.abbr}
        </Text>
        <Text scale={-2} mt={0.5} color={color.gray}>
          {props.description}
        </Text>
      </View>
    )}
  </StyledCoinNavLink>
);

const StyledCoinNavLink = styled(NavLink)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  padding: 0.5em;
  border-radius: 100px;
  box-shadow: ${shadow.md};
  transition: all 300ms;
  @media (hover: hover) {
    :hover {
      transform: translateY(-2px);
      box-shadow: ${shadow.lg};
    }
  }
  :focus {
    box-shadow: 0 0 0 2px ${p => rgba(p.color, 0.5)};
    outline: none;
  }
  :active,
  &.active {
    transform: translateY(0);
    color: ${p => p.color};
    box-shadow: 0 0 0 2px ${p => p.color},
      0 0 24px 2px ${p => rgba(p.color, 0.15)};
  }
`;
